module.exports = __webpack_public_path__ + "static/media/saturnoApp.2dda3ac5.png";